
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  const scrollToExample = () => {
    const element = document.getElementById('example-section');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-[calc(100vh-48px)] flex bg-[#f8f8f0] text-blue-900 items-center">
      <div className="mx-auto px-6 md:px-12 text-center -mt-10 w-full">
        <img 
          alt="Real estate and bitcoin investment illustration" 
          loading="lazy" 
          width="828" 
          height="431" 
          decoding="async" 
          className="mx-auto pb-4 md:pb-8 max-w-3/4 md:max-w-1/2 max-h-[30vh] object-contain" 
          src="https://www.sovana.io/_next/image?url=%2Fhome.png&w=1920&q=75"
        />
        
        <div className="flex flex-col items-center justify-center gap-2">
          <h1 className="font-semibold text-orange-500 tracking-tight md:whitespace-nowrap w-full text-4xl md:text-[min(4.5vw,4.5rem)]">
            {t('heroTitle')}
          </h1>
          
          <div className="font-light text-blue-900 leading-tight md:mb-2 tracking-tight max-w-6xl mx-auto text-lg md:text-[min(2.5vw,2.5rem)]">
            <span className="md:hidden font-medium">
              {t('heroSubtitle1')} {t('heroSubtitle2')}
            </span>
            <span className="hidden md:inline">
              {t('heroSubtitle1')}<br />
              {t('heroSubtitle2')}
            </span>
          </div>
          
          <div className="h-1"></div>
          
          <div 
            className="leading-snug text-base md:text-2xl max-w-5xl mx-auto" 
            dangerouslySetInnerHTML={{ __html: t('heroDescription') }}
          />
          
          <div className="leading-snug text-xs md:text-base max-w-5xl mx-auto mt-2">
            <span className="md:hidden">
              <span dangerouslySetInnerHTML={{ __html: t('heroFootnote') }} />
            </span>
            <span className="hidden md:inline">
              <span dangerouslySetInnerHTML={{ __html: t('heroFootnote') }} />
            </span>
          </div>
          
          <div className="mb-10 mt-10 text-xs">
            <a 
              href="https://www.nytimes.com/2025/06/26/business/crypto-industry-housing-market.html" 
              className="cursor-pointer"
            >
              As featured in
              <img 
                alt="New York Times logo" 
                loading="lazy" 
                width="150" 
                height="22" 
                decoding="async" 
                className="mt-2" 
                src="https://www.sovana.io/_next/image?url=%2Fnyt.png&w=384&q=75"
              />
            </a>
          </div>
        </div>
        
        <div className="bg-[#f8f8f0]/70 p-2 rounded-xl absolute bottom-5 left-1/2 transform -translate-x-1/2 flex flex-col items-center text-center text-xs backdrop-blur-xs">
          <button 
            onClick={scrollToExample}
            className="font-bold cursor-pointer"
          >
            <div>scroll down</div>
            <div className="justify-center flex">
              <i className="ri-arrow-down-line text-lg"></i>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
